import * as React from "react"
import SimpleFormat from "../../../utils/SimpleFormat";
import { RentalAdvert, RentalAdvertTranslation } from "../../../types/types";
import ReadMore from "../../shared/advert/ReadMore";

type Props = {
  advert: RentalAdvert
  translation: RentalAdvertTranslation
}

export default (props: Props) : JSX.Element => (
  !!props.translation && props.translation.culture ?
    <>
      <div className="content-part">
        <h3>
          {I18n.t('rental_adverts.description.culture')}
        </h3>
        <div>
          <div className="description">
            <ReadMore height={180}>
              <SimpleFormat
                text={props.translation.culture}
              />
            </ReadMore>
          </div>
        </div>
      </div>
      <hr />
    </>
  : <></>
)
